<template>
  <v-container fluid tag="section">
    <v-data-table
      :headers="headers"
      :items="customers"
      item-key="id"
      class="table-layout theme--light"
      style="height: calc(100vh - 280px) !important;overflow-y: auto !important;"
      hide-default-footer
      disable-sort
    >
      <template v-slot:top />
      <template v-slot:no-data>
        <common-no-result />
      </template>

      <template v-slot:item.code="{item}">
        <span class="btn-detail">{{item.code}}</span>
      </template>
      <template v-slot:item.statusId="{item}">
        <span>{{dataStatus(item)}}</span>
      </template>
      <!-- <template v-slot:item.address="{item}">
        <v-tooltip bottom v-if="item.address.length > 32">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ item.address.substring(0, 32) + "..." }}</span>
          </template>
          {{item.address}}
        </v-tooltip>
        <span v-else>{{item.address}}</span>
      </template> -->
      <template v-slot:item.activeCodes="{item}">
        <span v-for="(i,key) in item.activeCodes" :key="key">{{ i }}<br></span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="clickDetailOrder(item.id)"
              class="mr-2"
              icon
              small
              color="primary"
              v-on="on"
            >
              <v-icon>mdi-file-document</v-icon>
            </v-btn>
          </template>
          <span>Xem chi tiết thông tin khách hàng</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
// import HandyScroll, {EventBus} from "vue-handy-scroll"
import moment from 'moment'
export default {
  components: {},
  props: {
    customers: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      headers: [
        { text: 'STT', value: 'id', align: 'center', width: 80 },
        { text: 'Tên con', value: 'customerFullName', align: 'center' },
        { text: 'Số điện thoại', value: 'mobile', align: 'center' },
        // { text: 'Địa chỉ', value: 'address', align: 'center' },
        { text: 'Mã sử dụng', value: 'activeCodes', align: 'center' }
      ]
    }
  },
  mounted() {
    // EventBus.$emit("update", this.$refs.handscrolls.$el)
  },
  updated() {
    // EventBus.$emit("update", this.$refs.handscrolls.$el)
  },
  methods: {
    clickDetailOrder(orderId) {
      // this.$router.push({
      // let route = this.$router.resolve({
      //   name: 'OrderDetail',
      //   params: {
      //     id: orderId,
      //   },
      //   query: {
      //     orderList: true,
      //   },
      // });
      // window.open(route.href, '_blank')
    },
    clickDetailCustomer(CustomerId) {
      let route = this.$router.resolve({
        name: 'DetailAgency',
        params: {
          id: CustomerId,
        },
      });
      window.open(route.href, '_blank')
    },
    dataStatus(item) {
      return `${_.get(item, 'statusId', '')}-${_.get(
        item,
        'paymentType',
        ''
      )}`;
    },
    formatDate(value) {
      if (value)
        return moment(value).format("DD-MM-YYYY HH:mm")
    }
  }
};
</script>

<style lang="css" scoped>
  .btn-detail {
    font-weight: 500;
    cursor: pointer;
  }
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #d1d1d1;
  }
</style>
